<template>
    <span contenteditable="false" 
    @click="test"
    class="information-unit">Testing Information Unit</span>
</template>

<script>
export default {
    methods: {
        test() {
            alert('testing');
        }
    }
}
</script>

<style lang="scss">
.formula .information-unit {
  background-color: rgb(152, 201, 221);
  padding: 2px;
}
</style>